module.exports = "https://portperrypedals.ca/_res/img/social-logo.62c6416.png";